import mixpanel from 'mixpanel-browser';

export const MIXPANEL_TOKEN = 'f7472639b53c00b8a3f74dd5864022e6';
// const PRODUCTION_HOST = "apps.acordofechado.com.br";

// const isProduction = () => {
//   if ( typeof window === "undefined" ) return false;
//   return window.location.hostname === PRODUCTION_HOST;
// };

export const initMixpanel = () => {
	// if ( !isProduction() ) return;

	mixpanel.init( MIXPANEL_TOKEN, {
		debug                   : false,
		track_pageview          : true,
		persistence             : 'localStorage',
		autocapture             : true,
		record_sessions_percent : 100,
	} );
};

export const trackEvent = ( name, properties ) => {
	// if ( !isProduction() ) {
	//   if ( process.env.NODE_ENV === "development" ) {
	//     console.log( "Mixpanel Event (Skipped):", name, properties );
	//   }
	//   return;
	// }
	mixpanel.track( name, properties );
};

export const identifyUser = ( id, properties ) => {
	// if ( !isProduction() ) return;

	mixpanel.identify( id );
	if ( properties ) {
		if ( !properties.name ) {
			const email = properties.email || properties.$email;
			if ( typeof email === 'string' ) {
				properties['$name'] = email.split( '@' )[ 0 ];
			}
		}
		console.log( 'properties', properties );
		mixpanel.people.set( properties );
	}
};

export default mixpanel;

